import { render, staticRenderFns } from "./RPModels.vue?vue&type=template&id=18965958&scoped=true"
import script from "./RPModels.vue?vue&type=script&lang=js"
export * from "./RPModels.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18965958",
  null
  
)

export default component.exports